/**
 * Status polling budget (plan/README.md 2.3, Free Plan: 100 000 requests/day): start at 3 s,
 * back off by factor 1.5 up to 15 s, give up after 3 min (≈ 15 requests per page view).
 */
import { PublicRegistrationState, STATUS_POLL_INITIAL_MS, STATUS_POLL_MAX_MS } from '@lsc/shared';

const BACKOFF_FACTOR = 1.5;

/** Delay before the next poll after `completedPolls` successful responses. */
export function statusPollDelay(completedPolls: number): number {
  const exponent = Math.max(completedPolls - 1, 0);
  return Math.min(
    Math.round(STATUS_POLL_INITIAL_MS * BACKOFF_FACTOR ** exponent),
    STATUS_POLL_MAX_MS,
  );
}

/** States that never change again from the participant's point of view – polling stops. */
export function isTerminalState(state: PublicRegistrationState): boolean {
  return (
    state === PublicRegistrationState.ACTIVE ||
    state === PublicRegistrationState.EXPIRED ||
    state === PublicRegistrationState.CANCELLED
  );
}
